import React from "react";
import { Flex, Span, Text } from "../../assets/ui";
import { StyledButton } from "../common/Button";
import {StyledModalBodyWrapper} from "./ui";

const CongratulationModal = ({ setActiveModal }) => {
  return (
    <StyledModalBodyWrapper p={"24px"} width={["90vw", "464px"]}>
      <Text
        textAlign="center"
        fontSize={"32px"}
        lineHeight={"40px"}
        fontWeight="bold"
        color="#233247"
        margin={["10px 0 16px", null, "46px 0 38px"]}
      >
        Thanks for requesting!
      </Text>
      <Flex flexDirection="column" alignItems="center" maxWidth="280px" color="#586981">
        <Span
          fontWeight="bold"
          mb="20px"
          fontSize="16px"
          lineHeight="20px"

        >
          We got your request !
        </Span>
        <Span
          textAlign="center"
          fontSize="16px"
          lineHeight="20px"
        >
          We look forward to showing you Exsportia <br />
          Changing the way we access sports and activities
        </Span>
      </Flex>

      <StyledButton
        marginTop={["50px", null, "25px"]}
        mb={['18px', '34px']}
        width={["208px", '256px']}
        onClick={() => setActiveModal('enterKey')}
      >
        Done
      </StyledButton>
      <Flex
        flexDirection="column"
        fontSize={["24px"]}
        fontWeight="600"
        color="#233247"
        lineHeight={["28px"]}
        justifyContent="center"
        alignItems="center"
      >
        <Span>The future of</Span>
        <Span>
          <Span color="#ED3163">sports</Span> is now!
        </Span>
      </Flex>
    </StyledModalBodyWrapper>
  );
};

export default CongratulationModal;
